import { Modal } from "@/components/Modal";
import { Classification } from "@/types/classification";

interface ClassificationModalProps {
    classification: Classification;
    onClose: () => void;
}

export const hasClassificationModal = (classification: Classification) => {
    return !!classification.explanation;
};

export const ClassificationModal = ({
    classification,
    onClose,
}: ClassificationModalProps) => {
    return (
        <Modal
            variant="popup"
            title={classification.name}
            style={{
                borderColor: classification.strong_border_color,
                borderWidth: 10,
            }}
            onClose={onClose}
        >
            {classification.explanation}
        </Modal>
    );
};
